function normalizeCodesHistory(rawHistory) {
  if (Array.isArray(rawHistory)) {
    return rawHistory;
  }

  if (typeof rawHistory === "string") {
    try {
      const parsed = JSON.parse(rawHistory);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  return [];
}

function getUploadedDocumentTypeIds(documents) {
  return new Set(
    (Array.isArray(documents) ? documents : [])
      .filter((document) => document?.file?.id)
      .map((document) => Number(document.deal_document_type?.id))
      .filter((id) => Number.isFinite(id) && id > 0)
  );
}

export default {
  getMissingRequiredDocumentNames(documentTypes, documents) {
    const uploadedTypeIds = getUploadedDocumentTypeIds(documents);

    return (Array.isArray(documentTypes) ? documentTypes : [])
      .filter((documentType) => documentType.required && !uploadedTypeIds.has(Number(documentType.id)))
      .map((documentType) => documentType.label || documentType.name)
      .filter(Boolean);
  },
  formatDealCode(deal) {
    if (!deal?.code) {
      return "-";
    }

    const history = normalizeCodesHistory(deal.codes_history);
    const sortedHistory = [...history].sort((a, b) => {
      const dateA = a?.created_at ? new Date(a.created_at).getTime() : 0;
      const dateB = b?.created_at ? new Date(b.created_at).getTime() : 0;
      return dateA - dateB;
    });

    const previousCode = sortedHistory[sortedHistory.length - 2]?.code;

    if (!previousCode) {
      return deal.code;
    }

    return `${deal.code} (${previousCode})`;
  },
  formatLoadingDate(loadingDate) {
    if (!loadingDate) {
      return "-";
    }

    const date = loadingDate.date || null;
    const week = loadingDate.week;
    const year = loadingDate.year;

    if (date && week && year) {
      return `${date} (W${week}, ${year})`;
    }

    if (date) {
      return date;
    }

    if (year && week) {
      return `${year}-W${week}`;
    }

    return "-";
  },
  formatProductLabel(product) {
    const meat = product?.meat?.value || "";
    const descriptions = (product?.descriptions || [])
      .map((item) => item?.value)
      .filter(Boolean)
      .join(", ");

    if (meat && descriptions) {
      return `${meat} - ${descriptions}`;
    }

    return meat || descriptions || "";
  },
  getProductLabels(deal) {
    return (Array.isArray(deal?.products) ? deal.products : [])
      .map((product) => this.formatProductLabel(product))
      .filter(Boolean);
  },
  getDealTypeChipColor(dealType) {
    const slug = dealType?.slug;

    if (slug === "truck") {
      return "orange";
    }

    if (slug === "container") {
      return "green";
    }

    return "primary";
  },
};
